<template>
    <div class="wrapper">

        <header
            class="loading-static"
            v-if="!startedTransaction"
        >
            <h1>
                <img src="../assets/logo.png" width="300" height="300" />
                <div class="loading-text loading-text-media" style="font-size: 70%;">
                    There are currently no slides published
                </div>
                <div class="loading-text">
                    Next update in
                </div>
                <div
                    class="loading-text-media"
                >
                    {{ millisToMinutesAndSeconds(time) }}
                </div>
            </h1>
            <div
                class="slow-connection-message"
                v-if="slowConnection"
            >
                Loading may take a while...
            </div>
        </header>

        <!-- header v-else class="loading">
            <h1 class="loading__text">
                Carregando <span>mural digital</span> <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                <div class="loading-slider">
                    <ul class="loading-slider__messages">
                        <li class="loading-slider__message">mural digital</li>
                        li class="loading-slider__message">slides</li>
                        <li class="loading-slider__message">imagens</li>
                    </ul>
                </div>
            </h1>
        </header> -->

        <header
            class="loading-static"
            v-else-if="startedTransaction"
        >
            <h1>
                <img src="../assets/logo.png" width="300" height="300" />
                <div class="loading-text">
                    Loading
                    <span v-if="slidesMediaCount > 0" class="loading-text-media">media</span>
                    <span v-else class="loading-text-media">settings</span>
                </div>
                <div v-if="slidesMediaCount > 0" class="loading-text-media">{{ slideLoadedMediaCount }} / {{ slidesMediaCount }}</div>
                <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </h1>
            <div
                class="slow-connection-message"
                v-if="slowConnection"
            >
                Loading may take a while...
            </div>
        </header>

        <div
            v-if="slowConnection"
            class="slow-connection-badge"
        >
            ⚠ Internet connection
        </div>

    </div>
</template>
<script lang="js">
import { ref } from 'vue'
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
export default {
    name: 'HomeView',

    computed: {
        ...mapState(['slides', 'device', 'loadedToken', 'loadedDevice', 'loadedSlidesData', 'loadedSlidesMedia', 'slowConnection', 'slidesMediaCount', 'slideLoadedMediaCount'])
    },

    methods: {
        ...mapActions(['authenticateDevice', 'loadSlides', 'loadSlidesMedia', 'loadCurrentWeather', 'loadCurrentTime']),
        async run() {
            if (!this.device.code) return
            this.startedTransaction = true
            try {
                await this.authenticateDevice(this.device.code.toUpperCase())
                await this.loadSlides()

                if (this.slides.length <= 0) {
                    return this.setupCountdownTimer()
                } else {
                    this.$router.push({ name: 'viewer' })
                }

                await this.loadCurrentWeather()
                await this.loadCurrentTime()
                // await this.loadSlidesMedia()
            } catch (error) {
                console.log(error)
                this.error = true

                this.errorData = {
                    message: error.message
                }

                this.setupCountdownTimer()
            } finally {
                this.startedTransaction = false
            }
        },

        setupCountdownTimer () {
            this.timeAhead = dayjs().add(5, 'minute')
            this.interval = setInterval(() => {
                this.time = this.timeAhead.valueOf() - dayjs().valueOf()

                if (this.time <= 0) {
                    this.time = 0
                    clearInterval(this.interval)
                    this.run()
                }
            }, 1000)
        }
    },

    mounted () {
        this.setupCountdownTimer()
    },

    beforeUnmount() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    },

    created () {
        if (!this.device.code) {
            this.$router.push({ name: 'home' })
        }
    },

    setup() {
        const code = ref(null)
        const startedTransaction = ref(false)
        const error = ref(false)
        const errorData = ref(null)

        const interval = ref(null)
        const timeAhead = ref(dayjs().add(5, 'minute'))
        const time = ref(null)

        const millisToMinutesAndSeconds = (millis) => {
            const minutes = Math.floor(millis / 60000)
            const seconds = ((millis % 60000) / 1000).toFixed(0)

            return minutes + ":" + (seconds < 10 ? "0" : "") + seconds
        }

        return {
            code,
            startedTransaction,
            error,
            errorData,
            interval,
            timeAhead,
            time,
            millisToMinutesAndSeconds
        }
    }
}
</script>
<style>
html,
body {
    margin: 0;
    padding: 0;
}

@font-face {
    font-family: UniviaPro;
    src: url('../assets/fonts/BakbakOne-Regular.ttf') format("truetype");
}

@font-face {
    font-family: UniviaPro;
    src: url('../assets/fonts/WorkSans-VariableFont_wght.ttf') format("truetype");
}

@font-face {
    font-family: UniviaPro;
    src: url('../assets/fonts/WorkSans-VariableFont_wght.ttf') format("truetype");
}

@font-face {
    font-family: UniviaPro;
    src: url('../assets/fonts/Questrial-Regular.ttf') format("truetype");
}
</style>
<style>
.wrapper {
    width: 100vw;
    height: 100vh;
    background: rgb(210, 210, 210);
    background: radial-gradient(circle, rgba(210, 210, 210, 1) 0%, rgba(172, 172, 172, 1) 100%);
    font-family: UniviaPro;
    display: flex;
    justify-content: center;
    align-items: center;
}

.center {
    padding: 30px 45px;
    border-radius: 10px;
    background-color: #FFFFFF;
    text-align: center;
    width: 460px;
    box-shadow: 0.1rem 0.6rem 1rem #989898;
    position: relative;
}

.form {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 5px;
}

.input-text {
    display: block;
    margin: 0;
    padding: 0.8rem 1.6rem;
    color: inherit;
    min-width: 320px;
    font-family: inherit;
    font-size: 1.6rem;
    font-weight: inherit;
    line-height: 1.8;
    border: none;
    border-radius: 0.4rem;
    outline: none;
    border: 1px solid #c9c9c9;
    text-transform: uppercase;
    text-align: center;
}

.button {
    display: block;
    margin: 0;
    padding: 0.8rem 1.6rem;
    color: inherit;
    font-family: inherit;
    font-size: 1.6rem;
    font-weight: inherit;
    line-height: 1.8;
    border: none;
    border-radius: 0.4rem;
    color: #FFFFFF;
    background-color: #2b3074 !important;
    border: 1px solid #2b3074;
    cursor: pointer;
}

.loading {
    display: flex;
    align-items: center;
    jsutify-content: center;
}

.loading-static{
    text-align: center;
    font-weight: bold;
    color: #fff;
    font-size: 1.3rem;
}
.loading-text{
    font-size: 4rem;
    text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
}

.loading-text-media {
    color: #2b3074 !important;
}
.loading__text {
    flex: 1 1 100%;
    width: 100%;
    text-align: center;
    font-size: 4rem;
    font-weight: bold;
    color: #fff;
    text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);
}

.loading-slider {
    display: inline-block;
    height: 1.5em;
    overflow: hidden;
    vertical-align: middle;
    -webkit-mask-image: linear-gradient(transparent, white, white, white, transparent);
    mask-image: linear-gradient(transparent, white, white, white, transparent);
    mask-type: luminance;
    mask-mode: alpha;
}

.loading-slider__messages {
    display: inline-block;
    margin: 0;
    padding: 0;
    list-style: none;
    /* -webkit-animation-name: messageslider;
    animation-name: messageslider;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-duration: 10s;
    animation-duration: 10s; */
}

.loading-slider__message {
    display: block;
    line-height: 1.3em;
    text-align: left;
    color: #2b3074 !important;
}

.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}

.slow-connection-message{
    color: #2b3074 !important;
}

.slow-connection-badge {
    color: #ffffff;
    padding: 10px;
    background-color: red;
    border-radius: 10px;
    position: fixed;
    bottom: 5px;
}

.error {
    padding: 5px;
    background-color: red;
    color: #ffffff;
    font-family: UniviaPro;
    font-size: 18px;
    margin-top: 10px;
    border-radius: 14px;
}

@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(0);
    }
}

@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }

    100% {
        transform: translate(24px, 0);
    }
}


@-webkit-keyframes messageslider {

    0%,
    27% {
        transform: translateY(0%);
    }

    33%,
    60% {
        transform: translateY(-25%);
    }

    66%,
    93% {
        transform: translateY(-50%);
    }

    100% {
        transform: translateY(-75%);
    }
}

@keyframes messageslider {

    0%,
    27% {
        transform: translateY(0%);
    }

    33%,
    60% {
        transform: translateY(-25%);
    }

    66%,
    93% {
        transform: translateY(-50%);
    }

    100% {
        transform: translateY(-75%);
    }
}
</style>